import {FC, useCallback, useMemo} from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import moment from 'moment';

import { getCasinoTournamentNextInstances } from '../../store/selectors';
import Button from '../common/Button';
import './styles.scss';

interface TournamentMissionButtonProps {
  data: any
}

const TournamentMissionButton:FC<TournamentMissionButtonProps> = ({data}) => {
  const { t } = useTranslation();

  const casinoTournamentNextInstances = useSelector(getCasinoTournamentNextInstances);

  const tourData = casinoTournamentNextInstances?.[data?.prize?.tourInstanceId];

  const isPlayerFinishedTournament = useMemo(() => tourData?.tournamentData?.playerStatus === 'finished', [tourData]);

  const gameBoxTournamentMissionStatusText = useMemo(() => {
    if (data && tourData) {
      return data.status === 'completed' ? (isPlayerFinishedTournament ? 'finished' : 'completed') : 'notCompleted';
    }
    return '';
  }, [data, isPlayerFinishedTournament, tourData]);

  const isSpinsConsumed = useMemo(
      () =>
          tourData?.tournamentData?.playerStatus === 'finished' ||
          moment(tourData?.tournamentData?.endDate).isBefore(moment()),
      [tourData]
  );

  const goToTournamentGame = useCallback(() => {

    if (
        tourData &&
        !isSpinsConsumed &&
        !isPlayerFinishedTournament &&
        tourData?.tournamentData &&
        data?.status === 'completed'
    ) {
      window.parent.postMessage({ type: 'CLOSE_GAME_BOX' }, '*');
      localStorage.removeItem('gameUrl');

      if (!moment(tourData.tournamentData?.startDate).isBefore(moment())) {
        window.parent.postMessage({ type: 'CHANGE_CATEGORY', category: 'casinoTournament' }, '*');
      } else {
        window.parent.postMessage(
            {
              type: 'OPEN_TOURNAMENT_MODULE_GAME',
              data: tourData?.tournamentData,
            },
            '*'
        );
      }
    }
  }, [tourData, isSpinsConsumed, isPlayerFinishedTournament, data?.status]);

  const goToTournamentClasses = cn('go-to-tournament-button');

  return (
      <>
        {isPlayerFinishedTournament ? (
            <div
                className="tournament-mission-info-widget-container__tournament-info--description"
                dangerouslySetInnerHTML={{
                  __html: t(`gameBoxTournamentMissionStatus.${gameBoxTournamentMissionStatusText}`, {
                    tournamentName: tourData?.tournamentData?.tournamentName,
                    playerPosition: tourData?.tournamentData?.playerPosition,
                  }) as string,
                }}
            ></div>
        ) : (
            <div className="tournament-mission-info-widget-container__tournament-link">
              <div className={goToTournamentClasses}>
                <Button
                    size="md"
                    onClick={goToTournamentGame}
                    className={cn('play-btn', {
                      active: data?.status === 'completed' && !isSpinsConsumed && !isPlayerFinishedTournament,
                    })}
                >
                  {t('goToTournament')}
                </Button>
              </div>
            </div>
        )}
      </>
  );
};

export default TournamentMissionButton;
